import dayjs from 'dayjs'
import 'dayjs/locale/pt-br'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from 'react-query'
import { ReactQueryDevtools } from 'react-query/devtools'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

import { AppRoutes } from './routes'
import { AuthProvider } from './contexts/AuthContext'

import './styles/index.css'

dayjs.locale('pt-br')

const container = document.getElementById('root')
const queryClient = new QueryClient()

if (container !== null) {
  createRoot(container).render(
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <AppRoutes />
        <ToastContainer />
      </AuthProvider>
      <ReactQueryDevtools />
    </QueryClientProvider>
  )
}